import type { RestAdminResellerInvoiceOverviewItem } from "@KassaroAB/shared/types/invoices/resellerInvoice";
import { api } from "../utils/api";

export const getAdminResellerInvoicesApi = async (period: string) => {
  return api.get<RestAdminResellerInvoiceOverviewItem[]>(
    `admin/resellerInvoices/${period}`,
  );
};
